import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-chances {
  padding: 40px 0 56px;
  background: #fff;
  overflow: hidden;
}

#partiu-gp-chances .eyebrow {
  margin: 0 0 4px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}

#partiu-gp-chances .titulo {
  margin: 0 0 24px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
}

#partiu-gp-chances .card {
  position: relative;
  background: #f6f6f6;
  border-radius: 24px;
  padding: 24px;
  width: 212px;
  flex: 0 0 212px;
  min-height: 170px;
  margin-right: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
}

#partiu-gp-chances .card-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
}

#partiu-gp-chances .card-titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
}

#partiu-gp-chances .card-texto {
  margin: 0;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

#partiu-gp-chances .disclaimer {
    margin: 30px 0 0;
    color: #444;
    font-family: "SantanderMicroText";
    font-size: 12px;
    line-height: 18px;
    text-align: center;

}

#partiu-gp-chances .cta {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: fit-content;
  margin: 24px auto 0;
  padding: 0 32px;
  border-radius: 999px;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 350ms linear;
}

#partiu-gp-chances .cta:hover {
  background-color: #f14c4c;
}

@media (min-width: 992px) {
  #partiu-gp-chances .eyebrow {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  #partiu-gp-chances .titulo {
    margin: 0 0 44px;
    font-size: 54px;
    line-height: 62px;
  }

  #partiu-gp-chances .cards {
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 24px;
  }

  #partiu-gp-chances .cards .card {
    flex: 0 0 212px;
    width: 212px;
    min-width: 0;
    margin-right: 0;
  }

  #partiu-gp-chances .plus {
    display: flex;
    align-items: center;
    color: #ec0000;
    font-family: 'SantanderHeadline';
    font-size: 32px;
    font-weight: 800;
  }
}
`;

export default styles;